import { render, staticRenderFns } from "./NewPinsComp.vue?vue&type=template&id=37e0950e&"
import script from "./NewPinsComp.vue?vue&type=script&lang=js&"
export * from "./NewPinsComp.vue?vue&type=script&lang=js&"
import style0 from "./NewPinsComp.vue?vue&type=style&index=0&id=37e0950e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports